import React from "react";

import MainLayout from "components/MainLayout";
import MainList from "components/MainList";

import columns from "./columns";
import { Button } from "antd";
import { useNavigate } from "react-router-dom";

const BillingSummariesList = () => {
  const navigate = useNavigate();
  return (
    <MainLayout
      breadcrumbs={[{ name: "Moje faktury" }]}
      buttons={
        <Button
          type="primary"
          htmlType="button"
          onClick={() => navigate("/billings/current")}
        >
          Rozliczenia za obecny miesiąc
        </Button>
      }
    >
      <MainList
        columns={columns}
        query_name="billing_summaries"
        query_path="/billing_summaries"
        query_context="index"
        default_sort="period_start__desc"
        col_xl={5}
        col_lg={5}
        col_md={12}
        col_xs={24}
      />
    </MainLayout>
  );
};

export default BillingSummariesList;
